export default __webpack_public_path__ + "static/media/notif-example.7e298fc6.png";